import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { User, Compass, Library, Home } from 'lucide-react';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/dashboard', icon: Home, label: 'Home' },
    { path: '/wisdom-journey', icon: Compass, label: 'Journey' },
    { path: '/library', icon: Library, label: 'Library' },
    { path: '/profile', icon: User, label: 'Profile' },
  ];

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'rgba(26, 26, 26, 0.95)',
      borderTop: '1px solid rgba(212, 175, 55, 0.3)',
      padding: '1rem 0',
      backdropFilter: 'blur(10px)',
      zIndex: 1000
    }}>
      <div style={{
        maxWidth: '600px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center'
      }}>
        {navItems.map(item => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <button
              key={item.path}
              data-testid={`footer-${item.label.toLowerCase()}`}
              onClick={() => navigate(item.path)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '0.25rem',
                padding: '0.5rem 1.5rem',
                transition: 'all 0.3s ease',
                color: isActive ? '#d4af37' : '#999',
                transform: isActive ? 'translateY(-2px)' : 'none'
              }}
            >
              <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
              <span style={{
                fontSize: '0.75rem',
                fontFamily: 'Cinzel, serif',
                letterSpacing: '0.05em',
                fontWeight: isActive ? 600 : 400
              }}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}